import { useState ,useEffect} from "react";
import { getRubroById, postRubro, patchRubro } from "../../services/RubrosServices";
import { RubrosFormContext } from "./RubrosContext";
import { useNavigate, useParams } from 'react-router-dom';

export const RubrosFormState = ({ children }) => {
  const [report, setReport] = useState({});
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    if (id) getRubroByIdData(id)
}, [])

  const getRubroByIdData = async (id) => {
    let res = await getRubroById(id);
    if (res) setReport(res);
  };

  const postRubroData = async (body) => {
    const res = await postRubro(body);
    if (res) navigate("/Rubros");
  };

  const patchRubroData = async (id, body) => {
    const cleanedBody = { ...body };  
    delete cleanedBody.createdAt; 
    delete cleanedBody.updatedAt; 
    delete cleanedBody.deletedAt; 
    const res = await patchRubro(id, cleanedBody);
    if (res) navigate("/Rubros");
  };
  

  return (
    <RubrosFormContext.Provider value={{
      report,  
      postRubroData,
      patchRubroData,
    }}>
      {children}
    </RubrosFormContext.Provider>
  );
};
